import isEmpty from 'lodash/isEmpty';
import { type Dispatch, type SetStateAction, useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';

import { type QBankStructureCVForm, CheckboxType } from '../types';

export function useCheckboxState(
  data: QBankStructureCVForm['contentIds'],
  name?: string,
): [{ isChecked: boolean; checkboxState: CheckboxType }, Dispatch<SetStateAction<CheckboxType>>] {
  const { setValue } = useFormContext();
  const [checkboxState, setCheckboxState] = useState<CheckboxType>(CheckboxType.Unchecked);
  const values = Object.values(data).map((item) => item.isVisible);
  const isEmptyData = isEmpty(data);
  const isAllChecked = !isEmptyData && values.every(Boolean);
  const isSomeChecked = !isEmptyData && values.some(Boolean);

  useEffect(() => {
    if (isAllChecked) {
      if (name) setValue(name, true);
      setCheckboxState(CheckboxType.Checked);
    } else if (isSomeChecked) {
      if (name) setValue(name, true);
      setCheckboxState(CheckboxType.Indeterminate);
    } else {
      if (name) setValue(name, false);
      setCheckboxState(CheckboxType.Unchecked);
    }
  }, [isAllChecked, isSomeChecked]);

  return [{ isChecked: checkboxState !== CheckboxType.Unchecked, checkboxState }, setCheckboxState];
}
